import { JSX } from 'react';
import CheckBoxDone from '../../../assets/images/icons/checkbox.png';
import CheckBoxBlank from '../../../assets/images/icons/blank-check-box.png';
import './checkBox.css';

interface CheckBoxProps {
    isCompleted: boolean;
    onCompleteChange: (isCompleted:boolean) => void;
  }

const CheckBox = ({ isCompleted, onCompleteChange }: CheckBoxProps): JSX.Element => {
    return (
      <img src={isCompleted? CheckBoxDone: CheckBoxBlank} onClick={()=> onCompleteChange(!isCompleted)} className='checkBox-img'/>
    ); 
};

export default CheckBox;